import axiosClient from '../../configs/axios';


class CustomerMasterService {
    // Get list 
   async getCustomerList(params) {
    try {
        const response = await axiosClient.get(
            `/customers/list?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}&&depot_id=${params.depot_id || ''}`
        );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addCustomer(data) {
        try {
            const response = await axiosClient.post('/customers/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteCustomer(data) {
        try {
            const response = await axiosClient.put(`/customers/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new CustomerMasterService(); 